import ContactObjectCard from './ContactObjectCard'

export default ContactObjectCard
